module.exports = __webpack_public_path__ + "img/pricing_tab.83f9996b.jpg";